module.exports = __webpack_public_path__ + "img/bg-22222.34335b2e.png";